import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable()
export class IngetionService {
  pdfSelectedEvent: EventEmitter<Object> = new EventEmitter();
  documentAnnotationEvent: EventEmitter<Object> = new EventEmitter();
  ingetionCompleted: EventEmitter<Object> = new EventEmitter();
  documentTrainingCompleted: EventEmitter<Object> = new EventEmitter();

  constructor(private http: HttpClient) {

  }

  startIngetion(agentId, document_id, selected_node, range = "1-5") {
    let payload = {
      "node": selected_node,
      "range": range,
    };
  
    return this.http.post(environment.image_parser_service_api + 'image_parser/' + agentId + '/start_prediction/' + document_id, payload);
  }

  uploadDocuments(agentId, files) {
    const formData: FormData = new FormData();
    formData.append('files[]', files.file, files.filename);
    formData.append('profile', files.tagList[0] && files.tagList[0]._id ? files.tagList[0]._id : '');
  
    return this.http.post(environment.image_parser_service_api + 'image_parser/' + agentId + "/upload_documents", formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    }).pipe(
      catchError((err) => {
        console.log(err);
        return throwError(err);
      })
    );
  }



  saveWebLink(agentId, webLink) {
    return this.http.post(environment.image_parser_service_api + 'image_parser/' + agentId + "/save_web_link",
      { "type": "web", "url": webLink }, {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      }).pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }
  
getScripts(agentId) {
  return this.http.get(environment.image_parser_service_api + "image_parser/" + agentId + "/get_script", {})
    .pipe(
      catchError((err) => {
        console.log(err);
        return throwError(err);
      })
    );
}


  getIngestedDocuments(agentId, node) {
    return this.http.get(environment.image_parser_service_api + "image_parser/" + agentId + "/get_ingested_documents/" + node, {})
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }


  checkStatus(agentId, taskId) {
    return this.http.get(environment.image_parser_service_api + "image_parser/" + agentId + "/status/" + taskId)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  getDocumentFile(agentId, documentId, type) {
    if (type = "-pdf") {
      return this.http.get(environment.image_parser_service_api + "image_parser/" + agentId + "/fetch_document/" + documentId, { responseType: 'blob' })
    }
    else if ((type = "-doc") || (type = "-docx")) {
      return this.http.get(environment.image_parser_service_api + "image_parser/" + agentId + "/download_doc/" + documentId, { responseType: 'blob' })
    }
  }


  getIngestedDocumentImg(params, agentId) {
    if (params.type == "manual") {
      return this.http.post(environment.image_parser_service_api + "image_parser/" + agentId + "/upload_pages", params)
        .pipe(
          catchError((err) => {
            console.log(err);
            return throwError(err);
          })
        );
    }
    if (params.type == "automatic") {
      return this.http.post(environment.image_parser_service_api + "image_parser/" + agentId + "/autoannotate", params)
        .pipe(
          catchError((err) => {
            console.log(err);
            return throwError(err);
          })
        );
    }
  }

  getPagenumberList(topic, fileId, agentId, page_range) {
    return this.http.get(environment.image_parser_service_api + "image_parser/" + agentId + "/getpagenumbers/" + fileId + "/" + topic + "/" + page_range)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  updateIngestedAnnotate(params, agentId) {
    return this.http.post(environment.image_parser_service_api + "image_parser/" + agentId + "/ingest_pages", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  storeAnnotate(params, agentId) {
    return this.http.post(environment.image_parser_service_api + "image_parser/" + agentId + "/update_annots", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  automaticIngestion(params, agentId) {
    return this.http.post(environment.image_parser_service_api + "image_parser/" + agentId + "/auto_ingest", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  IngestedDocLoading(params, agentId) {
    return this.http.get(environment.image_parser_service_api + "image_parser/" + agentId + "/get_pages_in_topic/" + params.file_id + "/" + params.topic + "/" + params.page_range)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  
  getAnnotatedPage(pageId, agentId) {
    return this.http.get(environment.image_parser_service_api + "image_parser/" + agentId + "/getpage/" + pageId)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  getAnnotatedPageMetadata(pageId, agentId) {
    return this.http.get(environment.image_parser_service_api + "image_parser/" + agentId + "/refer_to_page/" + pageId)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  getAnnotedDocumentList(topic, agentId) {
    return this.http.get(environment.image_parser_service_api + "image_parser/" + agentId + "/get_document_list/" + topic)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  getUpdatedHeadingList(params, agentId) {
    return this.http.post(environment.image_parser_service_api + "image_parser/" + agentId + "/update_box", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  getTopMatchesConflicts(params, agentId) {
    return this.http.post(environment.image_parser_service_api + "image_parser/" + agentId + "/get_top_matches", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  resloveMatchConflicts(params, agentId) {
    return this.http.post(environment.image_parser_service_api + "image_parser/" + agentId + "/update_feature_value", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  saveScripts(params, agentId) {
    return this.http.post(environment.image_parser_service_api + "image_parser/" + agentId + "/save_script", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  updateScript(params, scriptId, agentId) {
    return this.http.put(environment.image_parser_service_api + "image_parser/" + agentId + "/" + scriptId + "/update_script", params)
      .pipe(
        catchError((err) => {
          console.log(err);
          return throwError(err);
        })
      );
  }

  uploadMultipleFiles(fileData, agentId) {
    const formData: FormData = new FormData();
    formData.append('file', fileData.file, fileData.filename);
    formData.append('tags', fileData.tagList);
    console.log(formData);
    return this.http.post(environment.image_parser_service_api + "document_library/" + agentId + "/upload_document", formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    }).pipe(
      catchError((error) => {
        console.log(error);
        return throwError(error);
      })
    );
  }

  listRecommendationDocuments(agentId, limit, offset) {
    return this.http.get(environment.image_parser_service_api + "document_library/" + agentId + "/documents?limit=" + limit + "&offset=" + offset)
      .pipe(
        catchError((error) => {
          console.log(error);
          return throwError(error);
        })
      );
  }

  deleteRecommendationDocument(agentId, documentId) {
    return this.http.delete(environment.image_parser_service_api + "document_library/" + agentId + "/documents/" + documentId)
      .pipe(
        catchError((error) => {
          console.log(error);
          return throwError(error);
        })
      );
  }
  repredictRecommendationDocument(agentId, documentId) {
    return this.http.post(environment.image_parser_service_api + "document_library/" + agentId + "/repredict", {"document_id": documentId})
      .pipe(
        catchError((error) => {
          console.log(error);
          return throwError(error);
        })
      );
  }

  updateDocumentTag(agentId, documentId, params) {
    return this.http.put(environment.image_parser_service_api + "document_library/" + agentId + "/documents/" + documentId, {"tags": params})
      .pipe(
        catchError((error) => {
          console.log(error);
          return throwError(error);
        })
      );
  }

  generateQuestions(params) {
    return this.http.post(environment.generateque_service + "/generateque", params)
      .pipe(
        catchError((error) => {
          console.log(error);
          return throwError(error);
        })
      );
  }
}
